// extracted by mini-css-extract-plugin
export default {"countryLink":"CountryLink_countryLink__BRHA-","countryLinkFlag":"CountryLink_countryLinkFlag__KEbxn","countryLinkText":"CountryLink_countryLinkText__3S8HF"};